export default function DashboardFMPLearnMore() {
  return (
    <div className='w-1/3 max-sm:w-full rounded-2xl shadow-md flex flex-col gap-4 text-white bg-ertc-secondary p-8'>
      <p className='font-bold text-3xl'>Learn More</p>
      <iframe className="w-full h-full" src="https://www.youtube.com/embed/umB5y1omDz0" title="What is &quot;Found Money&quot;?" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      <p onClick={() => window.open('https://foundmoneyproject.com')} className='bg-fmp-primary rounded-md p-2 text-center font-bold cursor-pointer'>www.foundmoneyproject.com</p>
    </div>
  )
}